import { Component, OnInit } from '@angular/core';
import moment from 'moment';
import { CommissionsDataService } from 'src/app/services/commissions-data.service';
import { LookupDataServiceService } from 'src/app/services/lookup-data-service.service';
import { NotificationService } from 'src/app/services/notification-service';
import { UserSessionService } from 'src/app/services/usersession.service';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { ExcelService } from 'src/app/services/excel.service';
import { FormBuilder, Validators } from '@angular/forms';
import * as _ from "lodash";

export const DATE_CELL = '__DATE__';

@Component({
    selector: 'app-commissions-report',
    templateUrl: './commissions-report.component.html',
    styleUrls: ['./commissions-report.component.scss']
})

export class CommissionsReportComponent implements OnInit {

    ServiceProviderList: any = [];
    dropdownSettings: any = {};
    ApplicationStatusList: any = [];
    ResellerCodeList: any = [];
    SalesCodeList: any = [];
    sessionDataString: any;
    applicationlist: any;
    applicationRefType: any;
    customerApplications: any;
    excelColumns: string[];
    commissionForm: any;
    slide: boolean = false
    toMinDate: any;
    toMaxDate: any;

    constructor(
        private sessionService: UserSessionService,
        private toastr: NotificationService,
        private lookupDataService: LookupDataServiceService,
        private commissionsDataServices: CommissionsDataService,
        private loaderService: LoaderService,
        private excelService: ExcelService,
        private lookUpService: LookupDataServiceService, private fb: FormBuilder,

    ) {

    }

    ngOnInit(): void {
        this.getServiceProvider()
        this.getApplicationStausType()
        this.getResellerList()
        this.getManageSalesRepList()
        this.getApplicationReferenceString();
        this.dropdownSettings = {
            singleSelection: false,
            idField: "key",
            textField: "value",
            selectAllText: "Select All",
            unSelectAllText: "UnSelect All",
            allowSearchFilter: true,
        };
        this.init()
        this.sessionDataString = JSON.parse(localStorage.getItem(this.sessionService.localStorageSessionKey));
    }
    init() {
        this.toMaxDate = new Date(new Date().setDate(new Date().getDate()));
        this.commissionForm = this.fb.group({
            approvedApplicationstartdate: [null],
            approvedApplicationEnddate: [null],
            firstName: [''],
            lastName: [''],
            applicationReferenceNumber: [''],
            customerReferenceNumber: [''],
            serviceProviderIdList: [[]],
            applicationStatuslist: [[]],
            resellerCodeList: [''],
            salesRepCodelist: [''],
            applicationCancelRestrict: [false]
        });
    }
    openDatePicker(id) {
        const clickEvent = new Event('click');
        const elementToClick = document.getElementById(id);
        if (id = 'EDclickId') {
            this.toMinDate = this.commissionForm.controls["approvedApplicationstartdate"].value;

        }
        if (elementToClick) {
            elementToClick.dispatchEvent(clickEvent);
        }
    }


    addMonths(date, months) {
        const newDate = new Date(date);
        newDate.setMonth(newDate.getMonth() + months);
        return newDate;
    }

    getServiceProvider() {
        this.lookUpService.getServiceProvider().subscribe(res => {
            this.ServiceProviderList = _.orderBy(res, ["value"], ["asc"]);
        })
    }
    getApplicationStausType() {
        this.lookUpService.getApplicationStausType().subscribe(res => {
            this.ApplicationStatusList = _.orderBy(res, ["value"], ["asc"]);
        })
    }
    getResellerList() {
        this.lookUpService.getResellerList().subscribe(res => {
            this.ResellerCodeList = _.orderBy(res, ["value"], ["asc"]);
        })
    }
    getManageSalesRepList() {
        this.lookUpService.getManageSalesRepList().subscribe(res => {
            this.SalesCodeList = _.orderBy(res, ["value"], ["asc"]);
        })
    }
    getApplicationReferenceString() {
        this.lookupDataService.getApplicationReferenceString().subscribe((serviceResponse: any) => {
            this.applicationRefType = serviceResponse[2];
        });
    }

    // clearFilter() {
    //     this.init()
    // }
    clearFilter() {
        this.commissionForm.reset({
            approvedApplicationstartdate: null,
            approvedApplicationEnddate: null,
            firstName: '',
            lastName: '',
            applicationReferenceNumber: '',
            customerReferenceNumber: '',
            serviceProviderIdList: [],
            applicationStatuslist: [],
            resellerCodeList: '',
            salesRepCodelist: '',
            applicationCancelRestrict: false
        });

        this.slide = false;
        this.applicationlist = [];
        this.customerApplications = [];
    }


    Submit() {
        debugger
        if (!this.commissionForm.valid) {
            debugger
            this.toastr.showError("Please fill in all mandatory fields!")
            return;
        }
        let formValues = this.commissionForm.getRawValue()
        // var checkDate: any = new Date(formValues.approvedApplicationstartdate);
        // checkDate = checkDate.setMonth(checkDate.getMonth() + 1);
        // var checkEndDate = moment(checkDate).format("YYYY/MM/DD");
        if (formValues.approvedApplicationstartdate) {

            formValues.approvedApplicationstartdate = moment(formValues.approvedApplicationstartdate).format("YYYY/MM/DD");
        }
        if (formValues.approvedApplicationEnddate) {
            formValues.approvedApplicationEnddate = moment(formValues.approvedApplicationEnddate).format("YYYY/MM/DD");
        }
        // if (checkEndDate < formValues.approvedApplicationEnddate) {
        //     debugger
        //     this.toastr.showError("Start date to End date not exceed from one month")
        //     return;
        // }

        const filteredParams: any = {};

        if (formValues.approvedApplicationstartdate) {
            filteredParams.approvedApplicationstartdate = formValues.approvedApplicationstartdate;
        }

        if (formValues.approvedApplicationEnddate) {
            filteredParams.approvedApplicationEnddate = formValues.approvedApplicationEnddate;
        }
        if (formValues.serviceProviderIdList?.length) {
            filteredParams.serviceProviderIdList =
                formValues.serviceProviderIdList.map(x => x.key);
        }

        if (formValues.applicationStatuslist?.length) {
            filteredParams.applicationStatuslist =
                formValues.applicationStatuslist.map(x => x.key);
        }
        filteredParams.isCompletedToBeBilled = this.slide === true;

        this.commissionsDataServices
            .getAdvancedCommissionsReportsSearch(filteredParams)
            .subscribe(res => {
                this.applicationlist = res;
                this.customerApplications = res;
                this.exportAsXLSX();
            });
    }
    exportAsXLSX(): void {
        this.loaderService.start();
        setTimeout(() => {
            debugger
            if (!this.customerApplications || this.customerApplications.length === 0) {
                this.toastr.showInfo("No data available to export");
                this.loaderService.hide();
                return;
            }
            const excelList = [];
            this.excelColumns = [
                'Name',
                'Customer Reference Number',
                'Application Number',
                'Service Provider',
                'Product Code',
                'Reseller Code',
                'Sales Code',
                'Reseller Sales Code',
                'Monthly Amount (Excl VAT)',
                'Status',
                'Future Scheduled Status',
                'Future Scheduled Type',
                'Future Scheduled Date',
                'Future Scheduled End Date',
                'Approved Order Date',
                'Completed To Be Billed Date',
                'Retention Promo Code',
                'Retention Promo Applied Date',
                'Retention Promo Start Date',
                'Retention Promo End Date',
                'Retention Promo Status',
                'Last updated note',
                'Address',
                'City',
                'Region',
                'Move Order',
                'Application Type'
            ];
            const customerApplicationsForXLS: any[] = this.customerApplications
                .map(x => x)
                .sort((a, b) => a.applicationId - b.applicationId);

            customerApplicationsForXLS.forEach((item) => {
                excelList.push(this.getRow(item));
            });

            // for (let i = 1; i < excelList.length; i++) {
            //     debugger
            //     const row = excelList[i];
            //     row[0] = this.encryptCustomerName(row[0]); // Modify the name
            // }
            this.excelService.exportAsExcelFileForcomms(excelList, "CommissionReport_" + moment().format("DDMMYYYYHHmmss") + '.xlsx', this.excelColumns);
            this.loaderService.stop();
        }, 500);
    }
    filteredParams(formValues) {
        const filteredParams = {};
        for (const key in formValues) {
            if (formValues.hasOwnProperty(key)) {
                const value = formValues[key];
                if (value !== null && value !== '' && value !== false) {
                    filteredParams[key] = value;
                }
            }
        }
        return filteredParams;
    }
    maskName(name) {
        return name.split(' ').map(word => {
            if (word.length > 2) {
                return word[0] + word[1] + 'x'.repeat(word.length - 2);
            }
            return word;
        }).join(' ');
    }


    getRow(item) {
        return [
            this.maskName(item.customerName),
            item.customerReferenceNumber,
            item.referenceNumber,
            item.serviceProvider,
            item.productId,
            item.resellerCode,
            item.salesRepCode,
            item.resellerSalesCode,
            item.totalAmountExcludingVAT,
            item.applicationStatusTypeName,
            item.scheduleActiveStatusName,
            item.futureScheduleTypeName,
            { value: item.scheduleStartDateValue, type: DATE_CELL },
            { value: item.scheduleEndDateValue, type: DATE_CELL },
            { value: item.approvedApplicationDateValue, type: DATE_CELL },
            { value: item.connectionActivatedOnTsValue, type: DATE_CELL },
            item.retentionPromoCode,
            { value: item.retentionPromoAppliedDate, type: DATE_CELL },
            { value: item.retentionPromoStartDate, type: DATE_CELL },
            { value: item.retentionPromoEndDate, type: DATE_CELL },
            item.retentionPromoStatusTypeName,
            item.note,
            item.address,
            item.city,
            item.region,
            item.movingOrder,
            item.applicationTypeName

        ];
    }

    // encryptCustomerName(custName) {
    //     var encryptedName = "";
    //     if (custName) {
    //         var CustomerNameList = custName.split(" ");
    //         for (var i = 0; i < CustomerNameList.length; i++) {
    //             var temp = CustomerNameList[i];
    //             if (temp && temp.length > 2) {
    //                 var encryptedCustName = temp.slice(0, 2);
    //                 encryptedCustName += 'x'.repeat(temp.length - 2) + " ";
    //                 encryptedName += encryptedCustName;
    //             }
    //         }
    //     }
    //     return encryptedName;
    // }

}
